import React from 'react';

const UnauthorizedComponent = () => {
  return (
    <div className="unauthorized-container">
      <h1 className="unauthorized-title">Unauthorized Access</h1>
      <p>You do not have permission to access this page.</p>
      <p>Please contact your administrator.</p>
    </div>
  );
};

export default UnauthorizedComponent;
